import { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const EditModeContext = createContext();

export function useEditMode() {
  return useContext(EditModeContext);
}

export function EditModeProvider({ children }) {
  const [token, setToken] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [content, setContent] = useState({});

  useEffect(() => {
    const saved = localStorage.getItem("admin_token");
    if (saved) {
      axios.get(`${API}/admin/verify`, { headers: { Authorization: `Bearer ${saved}` } })
        .then(() => setToken(saved))
        .catch(() => localStorage.removeItem("admin_token"));
    }
  }, []);

  useEffect(() => {
    axios.get(`${API}/content/public`).then(res => setContent(res.data)).catch(() => {});
  }, []);

  const saveContent = useCallback(async (key, value) => {
    if (!token) return;
    setContent(prev => ({ ...prev, [key]: value }));
    try {
      await axios.put(`${API}/admin/content`, { [key]: value }, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (e) {
      console.error("Save failed:", e);
    }
  }, [token]);

  const value = {
    isAdmin: !!token,
    editMode: !!token && editMode,
    toggleEditMode: () => setEditMode(prev => !prev),
    content,
    saveContent,
    token,
    authHeader: token ? { headers: { Authorization: `Bearer ${token}` } } : {},
  };

  return <EditModeContext.Provider value={value}>{children}</EditModeContext.Provider>;
}
